const operations = {
  eq: (query) => {
    const splitted = query.split(' ')

    return { op: 'eq', value: [splitted[2]] }
  },
  in: (query) => {
    // Use a regular expression to find all numbers in the string
    const regex = /\d+/g
    let matches = query.match(regex)

    return { op: 'in' , value: matches}
  },
}

const map = {
  'status.name': operations.eq,
}


export default map